var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvidersWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7C6 6.44771 6.44772 6 7 6H16C16.5523 6 17 6.44772 17 7V16C17 16.5523 16.5523 17 16 17H7C6.44771 17 6 16.5523 6 16V7ZM31 32C31 31.4477 31.4477 31 32 31H41C41.5523 31 42 31.4477 42 32V41C42 41.5523 41.5523 42 41 42H32C31.4477 42 31 41.5523 31 41V32ZM30.3913 28.9771L27.2071 25.7929L25.7929 27.2071L28.9771 30.3913L30.3913 28.9771ZM21.6774 20.2632L25.6545 24.2403L24.2403 25.6545L20.2632 21.6774V25.8947H18.2632V18.2632H25.8947V20.2632H21.6774Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvidersWhite);
export default __webpack_public_path__ + "static/media/providers-white.696832ecee1a8f3e19cda8d6d5e6c082.svg";
export { ForwardRef as ReactComponent };